// Common
import { ComponentRef, Directive, input } from '@angular/core';

// Directives
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';

// Components
import {
  ColumnContextMenuComponent,
  ColumnContextMenuOrientation,
} from '@modules/tasks/components/column-context-menu/column-context-menu.component';

// Types
import { Column } from '@modules/tasks/types/column';
import { Section } from '@modules/common/types/section';

@Directive({
  selector: '[appProjectBoardColumnContextMenu]',
  standalone: false,
})
export class BoardColumnContextMenuDirective extends ContextMenuDirective {
  public readonly appProjectBoardColumnContextMenu = input.required<Column>();
  public readonly appProjectBoardColumnContextMenuSection = input<Section>();
  // List view stacks columns vertically, so labels read above/below/up/down instead of left/right.
  public readonly appProjectBoardColumnContextMenuOrientation = input<ColumnContextMenuOrientation>('horizontal');

  registerComponent() {
    return ColumnContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<ColumnContextMenuComponent>) {
    componentRef.setInput('column', this.appProjectBoardColumnContextMenu());
    componentRef.setInput('section', this.appProjectBoardColumnContextMenuSection());
    componentRef.setInput('orientation', this.appProjectBoardColumnContextMenuOrientation());
  }
}
